import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import { rootAction } from '../../redux';
import { cartContentItemAttrSelector } from '../../redux/selectors/cartContentSelector';
import CardCounter from './CardCounter';

const mapStateToProps = (_initialState, initialOwnProps) => {
  const vid = initialOwnProps.vid;
  const selector = createStructuredSelector({
    amount: cartContentItemAttrSelector(vid, 'amount'),
  });

  return state => selector(state);
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      updateCartItemAmount: rootAction.actionsList.updateCartItemAmount.request,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CardCounter);
